/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-alert */
import React, { useEffect, useMemo, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardHeader, Badge, Collapse, Button, Nav, NavItem, NavLink,
} from 'reactstrap';
import 'react-image-lightbox/style.css';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
// import BaseGrid from '../../components/Common/BaseGrid';

import { get, post } from '../../helpers/api_helper';
import { formatTime } from '../../utilities/timeFormat';
import WarehouseMapCanvas from '../../components/Warehouse/WarehouseMapCanvas';

function Pickroute(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [refresh] = useState(0);
  const [now, setNow] = useState(Date.now());
  const [mapOpen, setMapOpen] = useState(false);
  const [mapTab, setMapTab] = useState('optimized');
  const [optimizedMapStops, setOptimizedMapStops] = useState(null);
  const [optimizedRouteSegments, setOptimizedRouteSegments] = useState([]);
  const [optimizedMapLoading, setOptimizedMapLoading] = useState(true);
  const [optimizedMapError, setOptimizedMapError] = useState(false);
  const [optimizedRouteCost, setOptimizedRouteCost] = useState(null);
  const [sequenceMapStops, setSequenceMapStops] = useState(null);
  const [sequenceRouteSegments, setSequenceRouteSegments] = useState([]);
  const [sequenceRouteCost, setSequenceRouteCost] = useState(null);
  const [sequenceRouteLoading, setSequenceRouteLoading] = useState(false);
  const [sequenceRouteError, setSequenceRouteError] = useState(false);

  const formatElapsed = (timestamp) => {
    if (!timestamp) {
      return '--:--:--';
    }

    const duration = moment.duration(Math.max(0, now - moment(timestamp).valueOf()));
    const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
    const minutes = duration.minutes().toString().padStart(2, '0');
    const seconds = duration.seconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  };

  const formatDuration = (milliseconds) => {
    if (milliseconds === null || milliseconds === undefined || Number.isNaN(milliseconds)) {
      return '--:--:--';
    }

    const duration = moment.duration(Math.max(0, milliseconds));
    const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
    const minutes = duration.minutes().toString().padStart(2, '0');
    const seconds = duration.seconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  };

  const formatPickedAtLabel = (timestamp) => {
    if (!timestamp) {
      return '';
    }

    const date = moment(timestamp);
    const weekdayNames = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];

    return (
      <>
        {date.format('h:mm:ss a')}
        <br />
        {`${weekdayNames[date.day()]} ${date.format('M/D')}`}
      </>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pr = await get(`/api/warehouse/pick/${id}`);

        setData(pr);
        setLoading(false);
      } catch (e) {
        toastr.error('Error loading data');
      }
    };

    setLoading(true);
    fetchData();
  }, [refresh]);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchOptimizedMapStops = async () => {
      try {
        const route = await get(`/api/warehouse/map/route/pickroute/${id}`);
        if (cancelled) return;

        setOptimizedMapStops((route?.stops || [])
          .filter((stop) => stop.type === 'pick' && stop.unrecognized !== true)
          .map((stop) => ({
            label: stop.locations?.[0] || '',
            sequence: stop.sequence,
          }))
          .filter((stop) => stop.label));
        setOptimizedRouteSegments(route?.segments || []);
        setOptimizedRouteCost(Number(route?.totalCost));
      } catch (error) {
        if (!cancelled) {
          setOptimizedMapStops(null);
          setOptimizedRouteSegments([]);
          setOptimizedMapError(true);
          setOptimizedRouteCost(null);
        }
      } finally {
        if (!cancelled) setOptimizedMapLoading(false);
      }
    };

    setOptimizedMapStops(null);
    setOptimizedRouteSegments([]);
    setOptimizedMapLoading(true);
    setOptimizedMapError(false);
    setOptimizedRouteCost(null);
    fetchOptimizedMapStops();

    return () => { cancelled = true; };
  }, [id, refresh]);

  const nextUnpickedItem = data?.items?.find((item) => item.picked_at === null
    && item.void !== 1) || null;
  const lastPickedItem = data?.items?.filter((item) => item.picked_at !== null)
    .sort((a, b) => moment(b.picked_at).valueOf() - moment(a.picked_at).valueOf())[0] || null;
  const pickedItemsAscending = (data?.items || [])
    .filter((item) => item.picked_at !== null)
    .sort((a, b) => moment(a.picked_at).valueOf() - moment(b.picked_at).valueOf());
  const averagePickGap = pickedItemsAscending.length > 1
    ? pickedItemsAscending
      .slice(1)
      .reduce((sum, item, index) => (
        sum + (moment(item.picked_at)
          .valueOf() - moment(pickedItemsAscending[index].picked_at).valueOf())
      ), 0) / (pickedItemsAscending.length - 1)
    : null;
  const stopCount = data?.items?.length || 0;
  const totalQty = data?.items?.reduce((sum, item) => sum + Number(item.qty || 0), 0) || 0;
  const voidCount = data?.items?.filter((item) => item.void === 1).length || 0;
  const isFinished = loading === false && data?.finished_at !== null;
  const firstPickedItem = pickedItemsAscending[0] || null;
  const pickSpanDuration = firstPickedItem
    ? ((isFinished ? moment(lastPickedItem?.picked_at).valueOf() : now)
      - moment(firstPickedItem.picked_at).valueOf())
    : null;
  const pickerCounts = (data?.items || [])
    .filter((item) => item.picked_at !== null && item.picked_by)
    .reduce((acc, item) => {
      acc[item.picked_by] = (acc[item.picked_by] || 0) + 1;
      return acc;
    }, {});
  const orderedRouteStops = useMemo(() => (data?.items || []).map((item, index) => ({
    item,
    label: item.location?.label || '',
    sequence: index + 1,
  })), [data?.items]);
  const routeLocationLabels = useMemo(() => orderedRouteStops
    .filter((stop) => stop.label && Number(stop.item.void) !== 1)
    .map((stop) => ({
      label: stop.label,
      sequence: stop.sequence,
    })), [orderedRouteStops]);

  useEffect(() => {
    if (loading || data === null) return undefined;

    let cancelled = false;
    const measureSequenceRoute = async () => {
      setSequenceMapStops(null);
      setSequenceRouteSegments([]);
      setSequenceRouteCost(null);
      setSequenceRouteLoading(true);
      setSequenceRouteError(false);
      try {
        const route = await post('/api/warehouse/map/route', {
          locations: routeLocationLabels.map((stop) => stop.label),
          preserveOrder: true,
        });
        if (!cancelled) {
          setSequenceMapStops((route?.stops || [])
            .filter((stop) => stop.type === 'pick' && stop.unrecognized !== true)
            .map((stop) => ({
              label: stop.locations?.[0] || '',
              sequence: stop.sequence,
            }))
            .filter((stop) => stop.label));
          setSequenceRouteSegments(route?.segments || []);
          setSequenceRouteCost(Number(route?.totalCost));
        }
      } catch (error) {
        if (!cancelled) {
          setSequenceMapStops(null);
          setSequenceRouteSegments([]);
          setSequenceRouteCost(null);
          setSequenceRouteError(true);
        }
      } finally {
        if (!cancelled) setSequenceRouteLoading(false);
      }
    };

    measureSequenceRoute();
    return () => { cancelled = true; };
  }, [data, loading, routeLocationLabels]);

  const mapRouteStops = mapTab === 'optimized'
    ? (optimizedMapStops || [])
    : (sequenceMapStops || routeLocationLabels);
  const mapRouteSegments = mapTab === 'optimized'
    ? optimizedRouteSegments
    : sequenceRouteSegments;
  const activeRouteCost = mapTab === 'optimized'
    ? optimizedRouteCost
    : sequenceRouteCost;
  const activeRouteLoading = mapTab === 'optimized'
    ? optimizedMapLoading
    : sequenceRouteLoading;
  const activeRouteError = mapTab === 'optimized'
    ? optimizedMapError
    : sequenceRouteError;
  const activeRoutePending = activeRouteLoading
    || (!activeRouteError && !Number.isFinite(activeRouteCost));
  const optimizedRouteDistance = Number.isFinite(optimizedRouteCost)
    ? `${optimizedRouteCost.toLocaleString(undefined, { maximumFractionDigits: 1 })} ${t('map units')}`
    : null;
  const sequenceRouteDistance = Number.isFinite(sequenceRouteCost)
    ? `${sequenceRouteCost.toLocaleString(undefined, { maximumFractionDigits: 1 })} ${t('map units')}`
    : null;
  const activeRouteDistance = Number.isFinite(activeRouteCost)
    ? `${activeRouteCost.toLocaleString(undefined, { maximumFractionDigits: 1 })} ${t('map units')}`
    : null;
  const primaryPicker = Object.entries(pickerCounts)
    .sort((a, b) => b[1] - a[1])[0]?.[0] || data?.user_name || '-';

  const nextItemTitle = nextUnpickedItem?.inventory
    ? `${nextUnpickedItem.inventory.stock_id} / ${nextUnpickedItem.inventory.part_number}`
    : nextUnpickedItem?.kit
      ? `${nextUnpickedItem.kit.stock_id} / ${nextUnpickedItem.kit.sku}`
      : t('Unknown Item');

  const nextItemSubtitle = nextUnpickedItem?.inventory?.ship_desc
    || (nextUnpickedItem?.kit ? `KIT-${nextUnpickedItem.kit.stock_id}` : '-');

  const detailsItems = [
    {
      label: t('Generated By'),
      value: loading === true ? t('Loading...') : (data?.user_name || '-'),
    },
    {
      label: t('Stops'),
      value: loading === true ? t('Loading...') : stopCount,
    },
    {
      label: t('Items'),
      value: loading === true ? t('Loading...') : totalQty,
    },
    {
      label: t('Created'),
      value: loading === true ? t('Loading...') : moment(data?.created_at).toLocaleString(),
      fullWidth: true,
    },
  ];

  if (loading === false && data?.finished_at !== null) {
    detailsItems.push({
      label: t('Finished'),
      value: moment(data.finished_at).toLocaleString(),
      fullWidth: true,
    });
  }

  const routeCellBorder = '1px solid rgba(148, 163, 184, 0.28)';
  const routeMutedBorder = '1px solid rgba(148, 163, 184, 0.18)';

  return (
    <div className="page-content pickroute-page">
      <div className="container-fluid">
        <Row>
          <Col lg="12">
            <Row>
              <Col md="3">
                <Card className="pickroute-page__panel-card">
                  <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Details')}</CardHeader>
                  <CardBody className="p-2 pickroute-page__details-body" style={{ background: '#fbfdff' }}>
                    <div
                      className="rounded-3 p-2 mb-2 pickroute-page__details-hero"
                      style={{
                        background: 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.85)',
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-start gap-2 mb-1">
                        <div>
                          <div className="text-uppercase text-muted" style={{ letterSpacing: '0.08em', fontSize: '0.65rem' }}>
                            {t('Pickroute ID')}
                          </div>
                          <div className="fw-bold" style={{ fontSize: '1.1rem', lineHeight: 1.05, color: '#0f172a' }}>
                            {loading === true ? t('Loading...') : id}
                          </div>
                        </div>
                        <Badge
                          pill
                          color={isFinished ? 'success' : 'warning'}
                          className={isFinished ? '' : 'text-dark'}
                          style={{ fontSize: '0.65rem', padding: '0.35em 0.55em' }}
                        >
                          {loading === true ? t('Loading...') : (isFinished ? t('Finished') : t('In Progress'))}
                        </Badge>
                      </div>

                      <div className="d-flex justify-content-between align-items-end gap-3">
                        <div>
                          <div className="text-uppercase text-muted" style={{ letterSpacing: '0.08em', fontSize: '0.65rem' }}>
                            {t('Type')}
                          </div>
                          <div className="fw-semibold" style={{ color: '#334155', fontSize: '0.9rem', lineHeight: 1.15 }}>
                            {loading === true ? t('Loading...') : (data?.type || '-')}
                          </div>
                        </div>
                        <div className="text-end">
                          <div className="text-uppercase text-muted" style={{ letterSpacing: '0.08em', fontSize: '0.65rem' }}>
                            {t('Voids')}
                          </div>
                          <div className="fw-bold" style={{ color: voidCount > 0 ? '#b42318' : '#0f172a', fontSize: '1rem', lineHeight: 1.1 }}>
                            {loading === true ? t('Loading...') : voidCount}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row g-2">
                      {detailsItems.map((detail) => (
                        <div
                          key={detail.label}
                          className={detail.fullWidth ? 'col-12' : 'col-6 col-md-12'}
                        >
                          <div
                            className="h-100 rounded-3 p-2 pickroute-page__details-item"
                            style={{
                              background: '#fff',
                              border: '1px solid rgba(226, 232, 240, 0.95)',
                              boxShadow: '0 4px 12px rgba(15, 23, 42, 0.04)',
                            }}
                          >
                            <div className="text-uppercase text-muted mb-1" style={{ letterSpacing: '0.08em', fontSize: '0.65rem' }}>
                              {detail.label}
                            </div>
                            <div className="fw-semibold" style={{ color: '#334155', fontSize: detail.fullWidth ? '0.8rem' : '0.95rem', lineHeight: 1.2 }}>
                              {detail.value}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>

                <Card
                  className="border-0 overflow-hidden pickroute-page__pace-card"
                  style={{
                    background: 'linear-gradient(135deg, #101828 0%, #1d2939 45%, #b42318 100%)',
                    color: '#fff',
                    boxShadow: '0 18px 40px rgba(16, 24, 40, 0.28)',
                  }}
                >
                  <CardHeader
                    className="text-uppercase border-0"
                    style={{
                      background: 'rgba(255, 255, 255, 0.08)',
                      letterSpacing: '0.12em',
                    }}
                  >
                    {t('Race Pace')}
                  </CardHeader>
                  <CardBody
                    style={{
                      backgroundImage: 'repeating-linear-gradient(135deg, rgba(255,255,255,0.06) 0, rgba(255,255,255,0.06) 12px, transparent 12px, transparent 24px)',
                    }}
                  >
                    {!isFinished && (
                      <>
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div>
                            <div className="text-uppercase small opacity-75">{t('Next Up')}</div>
                            <div className="fw-bold fs-5">{nextUnpickedItem ? nextItemTitle : t('Route Complete')}</div>
                            <div className="small opacity-75">{nextUnpickedItem ? nextItemSubtitle : t('All stops picked')}</div>
                            <div className="small mt-2">
                              <span className="text-uppercase opacity-75">{t('Picker')}</span>
                              {' '}
                              <span className="fw-semibold">{primaryPicker}</span>
                            </div>
                          </div>
                          <Badge color={nextUnpickedItem ? 'warning' : 'success'} pill className="text-dark">
                            {nextUnpickedItem ? t('On Deck') : t('Finished')}
                          </Badge>
                        </div>

                        {nextUnpickedItem && (
                          <div className="mb-3 p-3 rounded" style={{ background: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(2px)' }}>
                            <div className="d-flex justify-content-between small text-uppercase opacity-75 mb-1">
                              <span>{t('Location')}</span>
                              <span>{t('Qty')}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-end">
                              <div className="fs-4 fw-bold">{nextUnpickedItem.location?.label || '-'}</div>
                              <div className="fs-4 fw-bold">{nextUnpickedItem.qty}</div>
                            </div>
                          </div>
                        )}

                        <div className="rounded p-3" style={{ background: 'rgba(0, 0, 0, 0.28)', border: '1px solid rgba(255,255,255,0.08)' }}>
                          <div className="small text-uppercase opacity-75 mb-1">{t('Time Since Last Pick')}</div>
                          <div
                            className="fw-bold"
                            style={{
                              fontSize: '2rem',
                              lineHeight: 1,
                              fontVariantNumeric: 'tabular-nums',
                              letterSpacing: '0.08em',
                            }}
                          >
                            {formatElapsed(lastPickedItem?.picked_at)}
                          </div>
                          <div className="small opacity-75 mt-2">
                            {lastPickedItem
                              ? `${t('Last pick')}: ${lastPickedItem.location?.label || '-'} - ${formatTime(lastPickedItem.picked_at)}`
                              : t('No picks yet')}
                          </div>
                        </div>

                        <div className="rounded p-3 mt-3" style={{ background: 'rgba(0, 0, 0, 0.28)', border: '1px solid rgba(255,255,255,0.08)' }}>
                          <div className="small text-uppercase opacity-75 mb-1">{t('Elapsed Pick Time')}</div>
                          <div
                            className="fw-bold"
                            style={{
                              fontSize: '2rem',
                              lineHeight: 1,
                              fontVariantNumeric: 'tabular-nums',
                              letterSpacing: '0.08em',
                            }}
                          >
                            {formatDuration(pickSpanDuration)}
                          </div>
                          <div className="small opacity-75 mt-2">
                            {firstPickedItem
                              ? `${t('From first pick')}: ${formatTime(firstPickedItem.picked_at)}`
                              : t('No picks yet')}
                          </div>
                        </div>
                      </>
                    )}

                    {isFinished && (
                      <>
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div>
                            <div className="text-uppercase small opacity-75">{t('Finish Summary')}</div>
                            <div className="fw-bold fs-5">{t('Route Complete')}</div>
                            <div className="small opacity-75">{formatTime(data.finished_at)}</div>
                          </div>
                          <Badge color="success" pill className="text-dark">
                            {t('Finished')}
                          </Badge>
                        </div>

                        <div className="rounded p-3 mb-3" style={{ background: 'rgba(0, 0, 0, 0.28)', border: '1px solid rgba(255,255,255,0.08)' }}>
                          <div className="small text-uppercase opacity-75 mb-1">{t('Avg Pick Time')}</div>
                          <div
                            className="fw-bold"
                            style={{
                              fontSize: '2rem',
                              lineHeight: 1,
                              fontVariantNumeric: 'tabular-nums',
                              letterSpacing: '0.08em',
                            }}
                          >
                            {formatDuration(averagePickGap)}
                          </div>
                          <div className="small opacity-75 mt-2">{t('Average time between picked stops')}</div>
                        </div>

                        <div className="rounded p-3 mb-3" style={{ background: 'rgba(0, 0, 0, 0.28)', border: '1px solid rgba(255,255,255,0.08)' }}>
                          <div className="small text-uppercase opacity-75 mb-1">{t('Elapsed Pick Time')}</div>
                          <div
                            className="fw-bold"
                            style={{
                              fontSize: '2rem',
                              lineHeight: 1,
                              fontVariantNumeric: 'tabular-nums',
                              letterSpacing: '0.08em',
                            }}
                          >
                            {formatDuration(pickSpanDuration)}
                          </div>
                          <div className="small opacity-75 mt-2">{t('From first pick to last pick')}</div>
                        </div>

                        <div className="row g-2">
                          <div className="col-6">
                            <div className="rounded p-3 h-100" style={{ background: 'rgba(255,255,255,0.08)' }}>
                              <div className="small text-uppercase opacity-75">{t('Stops')}</div>
                              <div className="fs-4 fw-bold">{stopCount}</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="rounded p-3 h-100" style={{ background: 'rgba(255,255,255,0.08)' }}>
                              <div className="small text-uppercase opacity-75">{t('Qty')}</div>
                              <div className="fs-4 fw-bold">{totalQty}</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="rounded p-3 h-100" style={{ background: 'rgba(255,255,255,0.08)' }}>
                              <div className="small text-uppercase opacity-75">{t('Voids')}</div>
                              <div className="fs-4 fw-bold">{voidCount}</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="rounded p-3 h-100" style={{ background: 'rgba(255,255,255,0.08)' }}>
                              <div className="small text-uppercase opacity-75">{t('Picker')}</div>
                              <div className="fs-6 fw-bold">{primaryPicker}</div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
              <Col md="9">
                <div className="mb-3">
                  <div className="d-flex justify-content-end align-items-center mb-2">
                    <Button
                      color="link"
                      className="p-0 text-decoration-none"
                      onClick={() => { setMapOpen((open) => !open); }}
                    >
                      {mapOpen ? t('Hide Map') : t('Show Map')}
                    </Button>
                  </div>
                  <Collapse isOpen={mapOpen}>
                    <Nav tabs className="mb-2">
                      <NavItem>
                        <NavLink
                          className={mapTab === 'optimized' ? 'active' : ''}
                          href="#optimized-route"
                          onClick={(event) => {
                            event.preventDefault();
                            setMapTab('optimized');
                          }}
                        >
                          {t('Optimized Route')}
                          {optimizedRouteDistance && (
                            <Badge color="info" pill className="ms-2">
                              {optimizedRouteDistance}
                            </Badge>
                          )}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={mapTab === 'sequence' ? 'active' : ''}
                          href="#sequence-route"
                          onClick={(event) => {
                            event.preventDefault();
                            setMapTab('sequence');
                          }}
                        >
                          {t('Sequence Route')}
                          {sequenceRouteDistance && (
                            <Badge color="secondary" pill className="ms-2">
                              {sequenceRouteDistance}
                            </Badge>
                          )}
                        </NavLink>
                      </NavItem>
                    </Nav>
                    {activeRoutePending && (
                      <div className="text-muted py-3 text-center">
                        {t('Measuring route...')}
                      </div>
                    )}
                    {activeRouteError && (
                      <div className="alert alert-warning mb-2" role="alert">
                        {t('This route could not be measured on the warehouse map.')}
                      </div>
                    )}
                    {!activeRoutePending && !activeRouteError && (
                      <>
                        <div className="small text-muted mb-2">
                          {t('Round trip')}
                          {': '}
                          <strong>{activeRouteDistance}</strong>
                        </div>
                        <WarehouseMapCanvas
                          layoutModeType={props.layoutModeType}
                          locations={mapRouteStops}
                          routeSegments={mapRouteSegments}
                          title={mapTab === 'optimized'
                            ? t('Optimized Route Preview')
                            : t('Sequence Route Preview')}
                        />
                      </>
                    )}
                  </Collapse>
                </div>

                <Card className="pickroute-page__panel-card pickroute-page__route-shell">
                  <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Route')}</CardHeader>
                  <CardBody>
                    <div>
                      <Row>
                        {loading === false && orderedRouteStops.map(({ item, sequence }) => (
                          <Col key={item.id} className="mb-4 table-responsive" md="6">
                            <div
                              className="overflow-hidden pickroute-page__route-card"
                              data-route-stop={sequence}
                              style={{
                                borderRadius: '14px',
                                border: routeMutedBorder,
                                background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
                                boxShadow: '0 10px 24px rgba(15, 23, 42, 0.05)',
                              }}
                            >
                              <div
                                className="d-flex align-items-center gap-2 px-3 py-2 pickroute-page__route-stop-heading"
                                style={{
                                  background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.12) 0%, rgba(14, 165, 233, 0.03) 100%)',
                                  borderBottom: routeCellBorder,
                                }}
                              >
                                <span className="text-uppercase text-muted small">{t('Stop')}</span>
                                <Badge color="info" pill>{sequence}</Badge>
                              </div>
                              <table className="table table-sm mb-0 pickroute-page__route-table" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                                <thead>
                                  <tr>
                                    <td
                                      className="bg-soft"
                                      style={{
                                        width: '50px',
                                        borderRight: routeCellBorder,
                                        borderBottom: routeCellBorder,
                                        fontWeight: 500,
                                      }}
                                    >
                                      {t('Qty')}
                                    </td>
                                    <td
                                      className="bg-soft"
                                      style={{
                                        width: '100px',
                                        borderRight: routeCellBorder,
                                        borderBottom: routeCellBorder,
                                        fontWeight: 500,
                                      }}
                                    >
                                      {t('Location')}
                                    </td>
                                    <td
                                      className="bg-soft"
                                      style={{
                                        borderRight: routeCellBorder,
                                        borderBottom: routeCellBorder,
                                        fontWeight: 500,
                                      }}
                                    >
                                      {t('Lot')}
                                    </td>
                                    <td
                                      className="bg-soft"
                                      style={{
                                        width: '150px',
                                        borderBottom: routeCellBorder,
                                        fontWeight: 500,
                                      }}
                                    >
                                      {t('Serial')}
                                    </td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        borderRight: routeCellBorder,
                                        borderBottom: routeCellBorder,
                                      }}
                                    >
                                      {item.qty}
                                    </td>
                                    {item.location !== null && (
                                      <td
                                        style={{
                                          borderRight: routeCellBorder,
                                          borderBottom: routeCellBorder,
                                        }}
                                      >
                                        <strong>{item.location.label}</strong>
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        borderRight: routeCellBorder,
                                        borderBottom: routeCellBorder,
                                      }}
                                    >
                                      {item.lot}
                                    </td>
                                    <td style={{ borderBottom: routeCellBorder }}>{item.serial}</td>
                                  </tr>
                                  <tr>
                                    <td className="bg-white" colSpan="3" style={{ borderRight: routeCellBorder, borderBottom: routeCellBorder }}>
                                      {item.inventory !== null && (
                                        <div className="hstack gap-3 py-1">
                                          <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                              width: '84px',
                                              minWidth: '84px',
                                              height: '84px',
                                              borderRadius: '12px',
                                              background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
                                              border: routeMutedBorder,
                                            }}
                                          >
                                            <img src={`/api/inventory/thumbnail/${item.inventory.id}`} style={{ maxWidth: '70px', maxHeight: '70px' }} alt={item.inventory.ship_desc} />
                                          </div>
                                          <div>
                                            <div className="fs-6 fw-bold">
                                              {`${item.inventory.stock_id} / ${item.inventory.part_number}`}
                                            </div>
                                            <Link to={`/inventory/${item.inventory.id}`}>{item.inventory.ship_desc}</Link>
                                          </div>
                                        </div>
                                      )}
                                      {item.kit !== null && (
                                        <div className="hstack gap-3 py-1">
                                          <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                              width: '84px',
                                              minWidth: '84px',
                                              height: '84px',
                                              borderRadius: '12px',
                                              background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
                                              border: routeMutedBorder,
                                            }}
                                          >
                                            <img src={`/api/inventory/kit/thumbnail/${item.kit.id}`} style={{ maxWidth: '70px', maxHeight: '70px' }} alt={`KIT-${item.kit.stock_id}`} />
                                          </div>
                                          <div>
                                            <div className="fs-6 fw-bold">
                                              {`${item.kit.stock_id} / ${item.kit.sku}`}
                                            </div>
                                            <Link to={`/kits/${item.kit.id}`}>{`KIT-${item.kit.stock_id}`}</Link>
                                          </div>
                                        </div>
                                      )}
                                    </td>
                                    <td className="align-middle text-center" style={{ borderBottom: routeCellBorder, background: 'rgba(248, 250, 252, 0.8)' }}>
                                      {item.picked_at !== null && (
                                        <>
                                          <small className="text-success">{t('Picked!')}</small>
                                          <br />
                                          <small className="text-muted">{formatTime(item.picked_at)}</small>
                                          <br />
                                          <small className="text-muted">{`By: ${item.picked_by}`}</small>
                                        </>
                                      )}
                                      {item.picked_at === null && (
                                        <small className="text-danger">{t('Not picked')}</small>
                                      )}
                                      {item.void === 1 && (
                                        <>
                                          <br />
                                          <small className="text-danger">{t('Void')}</small>
                                          <br />
                                          <small className="text-muted">{item.void_reason}</small>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan="3" style={{ borderRight: routeCellBorder }}>
                                      <small>
                                        <strong>{t('Orders')}</strong>
                                        <br />
                                        {
                                          Array
                                            .from(new Set(item.order_items.map(
                                              (orderItm) => orderItm.order.id,
                                            )))
                                            .map((orderId) => {
                                              const orderItem = item.order_items.find(
                                                (oi) => oi.order.id === orderId,
                                              );

                                              return (
                                                <React.Fragment key={orderId}>
                                                  <Link to={`/orders/${orderItem.order.id}`}>{orderItem.order.reference}</Link>
                                                  {' - '}
                                                  <Badge color={Number(orderItem.qty_unshipped) > 0 ? 'danger' : 'success'} className="ms-1">
                                                    {`${(Number(orderItem.qty) - Number(orderItem.qty_unshipped)).toString()}`}
                                                    /
                                                    {Number(orderItem.qty).toString()}
                                                    {' '}
                                                    {t('Packed')}
                                                  </Badge>
                                                  <br />
                                                </React.Fragment>
                                              );
                                            })
                                        }
                                      </small>
                                    </td>

                                    <td className="text-center" style={{ background: 'rgba(248, 250, 252, 0.55)' }}>
                                      {item.picked_at !== null && (
                                        <>
                                          <small className="text-muted">{item.cart != null ? `Cart: ${item.cart}` : 'Not on a cart'}</small>
                                          {item && item.slot != null && (
                                            <>
                                              <br />
                                              <small className="text-muted">{`Slot: ${item.slot}`}</small>
                                            </>
                                          )}
                                          {item && item.sticker != null && (
                                            <>
                                              <br />
                                              <small className="text-danger">{`Label: ${item.sticker}`}</small>
                                            </>
                                          )}
                                          {item && (
                                            <>
                                              <br />
                                              <small className="text-danger">{`Pickroute item ID: ${item.id}`}</small>
                                              {item.picked_at !== null && (
                                                <>
                                                  <br />
                                                  <small className="text-info">
                                                    {`${t('Picked')}:`}
                                                    {' '}
                                                    {formatPickedAtLabel(item.picked_at)}
                                                  </small>
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Pickroute.propTypes = {
  layoutModeType: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

Pickroute.defaultProps = {
  layoutModeType: 'light',
};

export default connect((state) => ({
  layoutModeType: state.Layout.layoutModeType,

}), {})(withTranslation()(Pickroute));
